import {Component, OnInit} from "@angular/core";
import {Subscription} from "rxjs/Subscription";
import {NGXLogger} from "ngx-logger";
import {TranslateService} from "@ngx-translate/core";
import {SharedService} from "../../shared/shared.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DonationService} from "../../payment/Donation.Services";
import {DonationInfo, DonationSuccess} from "../donation-info/donation-request";

@Component({
  selector: 'donation',
  templateUrl: './donation-success.component.html'
})
export class DonationSuccessComponent implements OnInit {
  lan: string;
  subscription: Subscription;
  constructor(private logger: NGXLogger,
              private translate: TranslateService, private sharedService: SharedService, private router: Router,
              private activatedRoute: ActivatedRoute, private donationService: DonationService) {
  }
  lang: string;
  url: any;
  donationSuccess: DonationSuccess;
  id: any;

  isSeries: boolean = false;

  ngOnInit() {
    this.sharedService.refreshData();
    this.donationSuccess = new DonationSuccess();
    this.activatedRoute.queryParams.subscribe(params => {
      this.id = params['transId'];
      this.getDonationInfo();
    });

    window.scroll(0, 0);
    this.lang = localStorage.getItem("lang");
    this.logger.debug('language is >>>>>>>>>>>' + this.lang);

    if (this.lang == "") {
      this.translate.use("ba");
      localStorage.setItem("lang", "ba");
    } else {
      this.translate.use(this.lang);
      localStorage.setItem("lang", this.lang);
    }
  }

  getDonationInfo(){
    this.donationService.donationStatus(this.id).subscribe(response => {
      console.log(response)
      if(response.body.resp_code == "0000") {
        this.donationSuccess = response.body.transaction
        console.log(this.donationSuccess)
      }
      else {
        this.router.navigate(['/donation/fail'])
      }
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/donation/donatio-return-url/donation-success.component.ts